import { FC, ReactNode } from "react";

import { StatTileStyled } from "../investigation.panel.styled";

/** A labelled headline-metric tile used across the investigation panel tabs. */
export const InvestigationStatTile: FC<{ label: string; value: ReactNode }> = ({
  label,
  value,
}) => (
  <StatTileStyled>
    <span className="tile-label">{label}</span>
    <span className="tile-value">{value}</span>
  </StatTileStyled>
);
